import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import { PaymentContext } from 'contexts/paymentContext';
import { paymentConsts } from 'constants/payment';
import maskAmount from 'utils/maskAmount';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import { turkishNumberWithSuffix } from 'utils/numberFormatters';
import LeftMenu from '../components/buying/LeftMenu';
import ContactUs from '../components/ContactUs';
import BuyForOfferMachine from '../components/BuyForOfferMachine';

const PaymentProcess = ({ t }) => {
  const { paymentData } = useContext(PaymentContext);

  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('buying'),
      url: '/content/buying/before-bidding',
    },
    {
      label: 'Ödeme Süreci',
      url: '/content/buying/payment-process',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="payment-process" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Ödeme Süreci</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  iyiMakina.com, alıcı ve satıcı arasındaki maddi ve hukuki işleri üstlenmektedir.
                  Alıcılar sorunsuz ve güvenceyle ödeme işlemini gerçekleştirirken, satıcılar ise güvenle ödemesini teslim alır.
                </p>
                <p>
                  Ödeme ve devir işlemlerinin tamamı iyiMakina Bilgi Teknolojileri A.Ş. üzerinden kurumsal bir yaklaşımla gerçekleşmektedir.
                  45 yıllık tecrübemizle, her aşamada alıcı ve satıcıların yanındayız.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Aynı Günde Devir İşlemi</h2>
              </div>
              <div className="col-15">
                <p>
                  İnternet sitemiz üzerinden satın aldığınız makinaların devrini güvenle yapalım. Üstelik 1 iş günü içinde işlemleri bitirelim.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Alıcılar için Platform Kullanım Ücreti</h2>
              </div>
              <div className="col-15">
                <p>
                  Satılan makinalardan platform kullanım ücreti olarak, alıcı kurum veya kişiden makina satış fiyatının %
                  {turkishNumberWithSuffix(paymentData.platformUsageFeePercentage)}
                  {' '}
                  tutarı talep edilmektedir.
                  Satış fiyatının %
                  {turkishNumberWithSuffix(paymentData.platformUsageFeePercentage)}
                  {' '}
                  tutarının
                  {' '}
                  {maskAmount(paymentConsts.PLATFORM_USAGE_FEE_MINIMUM_EUR, undefined, true)}
                  {' '}
                  Euro’dan az olduğu koşullarda, platform kullanım ücreti
                  {' '}
                  {maskAmount(paymentConsts.PLATFORM_USAGE_FEE_MINIMUM_EUR, undefined, true)}
                  {' '}
                  Euro olarak belirlenecektir.
                  Platform kullanım ücreti ödemeleri Havale veya EFT yoluyla gerçekleştirilmektedir. Platform kullanım ücreti ülke ve koşullara göre farklılık gösterebilmektedir.
                </p>
                <p>
                  Platform kullanım ücreti; iyiMakina Bilgi Teknolojileri ve Ticaret A.Ş'nin Teknokent içerisinde yer almasından dolayı 4196 sayılı kanun uyarınca KDV'den muaf tutulmaktadır.
                  Bu sebeple platform kullanım ücreti özelinde herhangi bir artı KDV maliyetine katlanmanız gerekmez.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Sorunsuz Ödeme</h2>
              </div>
              <div className="col-15">
                <p>
                  Ödemesini yaptığınız makinanın ödemesi iyiMakina.com’un havuz hesabında askıda bekler, makinayı sorunsuz teslim aldığınız an ödeme satıcıya aktarılır.
                </p>
              </div>
            </div>
            <BuyForOfferMachine />
            <ContactUs about="Ödeme Süreciyle" />
          </div>
        </div>
      </div>
    </main>
  );
};

PaymentProcess.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Ödeme Süreci',
    },
  };
};

PaymentProcess.Layout = Layout;

export default withTranslation('common')(PaymentProcess);
